import axios from 'axios';

export const getPackagesAsync = async () => {
  const { data } = await axios.get(`/packages`);

  return data;
};

export const getUserPackagesAsync = async () => {
  const { data } = await axios.get(`/packages/user`);

  return data;
};

export const purchasePackagesAsync = async ({
  packageId,
  currencyType,
  networkType,
  shippingInfo,
  billingInfo,
}: {
  packageId: number;
  currencyType: string;
  networkType: string;
  shippingInfo: any;
  billingInfo?: any;
}) => {
  return await axios.post(`/packages/purchase`, {
    packageId,
    currencyType,
    networkType,
    shippingInfo,
    billingInfo,
  });
};

export const getPackagesDetailsAsync = async (id: number) => {
  const { data } = await axios.get(`/packages/${id}/details`);

  return data;
};

export const cancelPaymentAsync = async (id: number) => {
  const { data } = await axios.put(`/packages/${id}/cancel`);

  return data;
};
